module.exports = __webpack_public_path__ + "static/media/Fran1-2.4bfa687b.jpg";